import type {
  BulkDownloadableWork,
  BulkDownloadTrigger,
} from 'js/bulk_download/bulk_download_helper';
import type { BulkDownloadCountsResponse } from 'js/bulk_download/bulk_download_counts_cache';
import type { ModalContext, ResolvedArm } from './AutotestBulkDownload';
import type renderModalFn from 'js/utils/renderModal';
import type { WorkId } from 'js/liswp/types';

export type ModalHandlerContext = {
  arm: ResolvedArm;
  renderModal: typeof renderModalFn;
  work: BulkDownloadableWork;
  trigger: BulkDownloadTrigger;
  ctx: ModalContext;
  countsData: BulkDownloadCountsResponse;
  afterFirstModalClose: () => void;
  eligibleForTransactionalPricing: boolean;
  landingPageUrl?: string;
};

export type ModalHandler = (context: ModalHandlerContext) => void;

export type DownloadInterceptorContext = {
  arm: ResolvedArm;
  work: {
    id: WorkId;
    title: string;
    downloadableAttachment?: { downloadUrl?: string };
  };
  trigger: BulkDownloadTrigger;
  downloadWork: () => void;
  recordClickTimestamp: (workId: WorkId) => void;
};

export type DownloadInterceptor = (context: DownloadInterceptorContext) => void;

const R_VARIANT_SUFFIX = /_r\d+$/;

export function isRVariantArm(arm: string | undefined): arm is string {
  return arm != null && R_VARIANT_SUFFIX.test(arm);
}
